import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationTR from './locales/tr.json';
import translationEN from './locales/en.json';

// Dil kaynakları
const resources = {
  tr: {
    translation: translationTR
  },
  en: {
    translation: translationEN
  }
};

i18n
  // Tarayıcı dilini otomatik algıla
  .use(LanguageDetector)
  // react-i18next'i kullan
  .use(initReactI18next)
  // i18n'i başlat
  .init({
    resources,
    fallbackLng: 'tr', // Varsayılan dil Türkçe
    debug: false, // Debug modunu kapat
    
    // Dil algılama ayarları
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },

    interpolation: {
      escapeValue: false // React zaten XSS koruması yapıyor
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;

